<form>
    <div *ngIf="severityDispersionParameters" class="grid-x grid-padding-x align-spaced">
        <!-- Severity -->
        <div class="cell small-24 large-12 xxlarge-8">
            <h2 class="_sansSerif _primary"[i18nKey]="'evaluations.severity.dispersion.parameters.severity.axis'"></h2>
            <h3 class="_secondary"[i18nKey]="'evaluations.severity.dispersion.parameters.severity.severity.level'"></h3>
            <kiwi-spacer [size]="8"></kiwi-spacer>
            <div class="grid-x">
                <label class="cell small-6">
                    <input [(ngModel)]="severityDispersionParameters.severity"
                           max="{{severityDispersionParameters.maxSeverity}}"
                           min="{{severityDispersionParameters.minSeverity}}"
                           name="severity"
                           type="number"
                           (change)="onSeverityOrDispersionChange()">
                </label>
            </div>
            <kiwi-spacer [size]="16"></kiwi-spacer>
            <p>
                <b class="_primary">0
                    :</b> <span [i18nKey]="'evaluations.severity.dispersion.parameters.severity.lowest.severity.level'"> </span></p>
            <p>
                <b class="_primary">50
                    :</b> <span [i18nKey]="'evaluations.severity.dispersion.parameters.severity.average.severity.level'"> </span></p>
            <p><b class="_primary">100
                :</b> <span [i18nKey]="'evaluations.severity.dispersion.parameters.severity.highest.severity.level'"> </span></p>
        </div>

        <!-- Dispersion -->
        <div class="cell small-24 large-12 xxlarge-8">
            <h2 class="_sansSerif _primary"[i18nKey]="'evaluations.severity.dispersion.parameters.dispersion.axis'"></h2>
            <h3 class="_secondary"[i18nKey]="'evaluations.severity.dispersion.parameters.dispersion.dispersion.level'"></h3>
            <kiwi-spacer [size]="8"></kiwi-spacer>
            <div class="grid-x">
                <label class="cell small-6">
                    <input [(ngModel)]="severityDispersionParameters.dispersion"
                           max="{{severityDispersionParameters.maxDispersion}}"
                           min="{{severityDispersionParameters.minDispersion}}"
                           name="dispersion"
                           type="number"
                           (change)="onSeverityOrDispersionChange()">
                </label>
            </div>
            <kiwi-spacer [size]="16"></kiwi-spacer>
            <p><b class="_primary">0
                :</b> <span [i18nKey]="'evaluations.severity.dispersion.parameters.dispersion.lowest.dispersion.level'"> </span></p>
            <p><b class="_primary">50
                :</b> <span [i18nKey]="'evaluations.severity.dispersion.parameters.dispersion.average.dispersion.level'"> </span></p>
            <p><b class="_primary">100
                :</b> <span [i18nKey]="'evaluations.severity.dispersion.parameters.dispersion.highest.dispersion.level'"> </span></p>
        </div>
    </div>

    <kiwi-spacer [size]="24"></kiwi-spacer>

    <div class="grid-x grid-padding-x align-spaced" *ngIf="severityDispersionParameters">
        <kiwi-notation-information class="cell small-24 large-12 xxlarge-8"
                                   [notationInformation]="marksBeforeChanges"
                                   [maximumMark]="maxMark"
                                   [titleLabelKey]="'evaluations.severity.dispersion.parameters.base.results'"
                                   [minimumLabelKey]="'evaluations.severity.dispersion.parameters.notation.minimal'"
                                   [averageLabelKey]="'evaluations.severity.dispersion.parameters.notation.average'"
                                   [maximumLabelKey]="'evaluations.severity.dispersion.parameters.notation.maximal'">
        </kiwi-notation-information>
        <kiwi-notation-information class="cell small-24 large-12 xxlarge-8"
                                   [notationInformation]="marksAfterChanges"
                                   [maximumMark]="maxMark"
                                   [titleLabelKey]="'evaluations.severity.dispersion.parameters.expected.results'"
                                   [minimumLabelKey]="'evaluations.severity.dispersion.parameters.final.notation.minimal'"
                                   [averageLabelKey]="'evaluations.severity.dispersion.parameters.final.notation.average'"
                                   [maximumLabelKey]="'evaluations.severity.dispersion.parameters.final.notation.maximal'">
        </kiwi-notation-information>
    </div>

    <kiwi-spacer [size]="48"></kiwi-spacer>

    <div class="grid-x align-center">
        <button (click)="onSave()" class="cell shrink button _iconLeft"
                type="submit"><i class="fas fa-save"></i> <span [i18nKey]="'common.action.save'"></span></button>
    </div>
</form>
